import { styled } from 'styled-components';

const StyledContainer = styled.div`
	margin-left: auto;
`;

export { StyledContainer };
